import * as Yup from 'yup';
import { emailRegex, phoneNumberRegex, websiteRegex } from '../../../util/validations';
import { BusinessTypeEnum, IndustryEnum, NumOfEmplyeesEnum } from '../../../commonTypes/organization.types';
import { useTranslation } from '../../../hooks/useTranslation';

type TFunction = ReturnType<typeof useTranslation>['t'];

const customFieldSchema = (t: TFunction) => {
    return Yup.array().of(
        Yup.object().shape({
            label: Yup.string().required(t('validationMessages.customFieldSchema.label.required')),
            name: Yup.string().required(t('validationMessages.customFieldSchema.name.required')),
            value: Yup.string().when(['label', 'name'], {
                is: (label: string, name: string) => label && name,
                then: Yup.string().required(t('validationMessages.customFieldSchema.value.required')),
                otherwise: Yup.string().optional(),
            }),
        })
    );
};

export const ORGANIZATION_SETTINGS_SCHEMA = (t: TFunction) => {
    return Yup.object().shape({
        logoUrl: Yup.string().optional(),
        name: Yup.string().required(t('validationMessages.ORGANIZATION_SETTINGS_SCHEMA.name.required')).trim().max(40),
        city: Yup.string().max(40),
        streetline1: Yup.string().max(40),
        streetline2: Yup.string().optional().max(40),
        country: Yup.object().shape({
            label: Yup.string(),
            value: Yup.string(),
        }),
        currency: Yup.object().shape({
            label: Yup.string(),
            value: Yup.string(),
        }),
        contact: Yup.string()
            .optional()
            .trim()
            .min(6)
            .max(30)
            .nullable()
            .matches(phoneNumberRegex, t('validationMessages.ORGANIZATION_SETTINGS_SCHEMA.contact.matches')),
        email: Yup.string().matches(emailRegex, t('validationMessages.ORGANIZATION_SETTINGS_SCHEMA.email.matches')).min(6).max(320),
        website: Yup.string().optional().matches(websiteRegex, t('validationMessages.ORGANIZATION_SETTINGS_SCHEMA.website.url')),
        industry: Yup.mixed<IndustryEnum>().oneOf(Object.values(IndustryEnum)).nullable(),
        numberOfEmployees: Yup.mixed<NumOfEmplyeesEnum>().oneOf(Object.values(NumOfEmplyeesEnum)).nullable(),
        businessType: Yup.mixed<BusinessTypeEnum>().oneOf(Object.values(BusinessTypeEnum)).nullable(),
        customFields: customFieldSchema(t),
        taxNumber: Yup.string().notRequired().trim().min(1, t('validationMessages.ORGANIZATION_SETTINGS_SCHEMA.taxNumber.min')),
        registrationNumber: Yup.string().notRequired().trim().min(1, t('validationMessages.ORGANIZATION_SETTINGS_SCHEMA.registrationNumber.min')),
    });
};
